module.exports = __webpack_public_path__ + "static/klyde-44b2a095b7bac8e15f56f58cd41b598a.png";